// assets
import { ReactComponent as NonVeg } from "assets/nonveg.svg";
import { ReactComponent as Veg } from "assets/veg.svg";
import { ReactComponent as Jain } from "assets/jain.svg";
import { ReactComponent as BreakFast } from "assets/breakfast.svg";

// style
import "./style.scss";
import { useTheme } from "components/ListingNew/ListingTheme";

export const MealPopUp = (
	data: any,
	flag: any,
	message: any,
	setOpen: any,
	listingList: any,
	isDiscount: boolean,
) => {
	const theme = useTheme();
	const id = listingList?.id;
	const htmlBody = (
		<div
			className="meal__popup__wrapper"
			id="meal-popup"
			style={{ background: theme?.background }}
		>
			{!!isDiscount && <b style={{ color: "green" }}>Get 5% off on meals!</b>}
			{message && (
				<div
					className="meal-popup-box"
					style={
						theme?.name === "xseries" ? { background: theme?.background2 } : {}
					}
				>
					{flag !== 3 && (
						<div
							className="meal-header"
							style={
								theme?.name === "xseries"
									? {
											color: theme?.primaryTextColor,
									  }
									: {}
							}
						>
							Add Meals
						</div>
					)}
					{message && (
						<p style={{ color: theme?.primaryTextColor }}>{message}</p>
					)}
				</div>
			)}
			{flag !== 3 && (
				<>
					<div
						className="meal-popup-box"
						style={
							theme?.name === "xseries"
								? {
										background: theme?.background2,
										color: theme?.primaryTextColor,
								  }
								: {}
						}
					>
						<div
							className="meal-header"
							style={
								theme?.name === "xseries"
									? {
											color: theme?.primaryTextColor,
									  }
									: {}
							}
						>
							Meals available at this villa
						</div>
						<div
							style={{
								display: "flex",
								gap: "25px",
							}}
						>
							<div
								className="meal-type"
								style={
									theme?.name === "xseries"
										? {
												color: theme?.primaryTextColor,
										  }
										: {}
								}
							>
								<Veg /> Veg
							</div>

							{data.isNonVeg && (
								<div
									className="meal-type"
									style={
										theme?.name === "xseries"
											? {
													color: theme?.primaryTextColor,
											  }
											: {}
									}
								>
									<NonVeg /> Non Veg
								</div>
							)}
							{data.isJain && (
								<div
									className="meal-type"
									style={
										theme?.name === "xseries"
											? {
													color: theme?.primaryTextColor,
											  }
											: {}
									}
								>
									<Jain /> Jain
								</div>
							)}
						</div>
					</div>
					<div
						className="meal-popup-box"
						style={
							theme?.name === "xseries"
								? {
										background: theme?.background2,
										color: theme?.primaryTextColor,
								  }
								: {}
						}
					>
						<div
							className="meal-header"
							style={
								theme?.name === "xseries"
									? {
											color: theme?.primaryTextColor,
									  }
									: {}
							}
						>
							Pricing
						</div>
						<h5
							style={
								theme?.name === "xseries"
									? {
											color: theme?.secondaryTextColor,
									  }
									: {}
							}
						>
							Per adult, per night
						</h5>
						{data.breakFastAvailable && <BreakFast />}
						{data.vegPrice !== 0 && (
							<div
								className="meal-price"
								style={{
									marginTop: "16px",
									color:
										theme?.name === "xseries" ? theme?.primaryTextColor : "",
								}}
							>
								<Veg
									style={{
										marginRight: "10px",
									}}
								/>
								{[
									"xKrFmWI9INr8OUTo",
									"s5BTeCcQcvr6thld",
									"h7RoH9qCXJcL88xj",
									"7BCI2TUSSFmR3iZP",
									"iLIql69vyblULH4r",
									"lU8CMLfiaElR57YM",
									"V5wWlgl0FPtsBJ3a",
								].includes(id)
									? "Breakfast + Dinner"
									: `${
											!data.breakFastAvailable ? "Breakfast + " : ""
									  }Lunch + Dinner`}{" "}
								<span
									style={
										theme?.name === "xseries"
											? {
													color: theme?.secondaryTextColor,
											  }
											: {}
									}
								>
									₹ {data.vegPrice}
									<h6>+GST</h6>
								</span>
							</div>
						)}
						{data.isNonVeg && data.nonVegPrice !== 0 && (
							<div
								className="meal-price"
								style={{
									marginTop: "16px",
									color:
										theme?.name === "xseries" ? theme?.primaryTextColor : "",
								}}
							>
								<NonVeg
									style={{
										marginRight: "10px",
										color:
											theme?.name === "xseries" ? theme?.primaryTextColor : "",
									}}
								/>
								{[
									"xKrFmWI9INr8OUTo",
									"s5BTeCcQcvr6thld",
									"h7RoH9qCXJcL88xj",
									"7BCI2TUSSFmR3iZP",
									"iLIql69vyblULH4r",
									"lU8CMLfiaElR57YM",
									"V5wWlgl0FPtsBJ3a",
								].includes(id)
									? "Breakfast + Dinner"
									: `${
											!data.breakFastAvailable ? "Breakfast + " : ""
									  }Lunch + Dinner`}{" "}
								<span
									style={
										theme?.name === "xseries"
											? {
													color: theme?.secondaryTextColor,
											  }
											: {}
									}
								>
									₹ {data.nonVegPrice} <h6>+GST</h6>
								</span>
							</div>
						)}
					</div>
				</>
			)}
			{flag === 3 && data.breakFastAvailable && (
				<div className="meal-popup-box">
					<BreakFast />
				</div>
			)}
			<button
				id="meal-btn"
				style={{
					color: theme?.name === "xseries" ? theme?.otherTextColor : "",
				}}
				onClick={() => {
					setOpen(false);

					//@ts-ignore
					// document.getElementById("Meals").scrollIntoView();
					// setTimeout(() => {
					// 	//@ts-ignore
					// 	document.getElementById("Meals").style.animation =
					// 		"hightligther 1s linear";
					// }, 250);
					// setTimeout(() => {
					// 	//@ts-ignore
					// 	document.getElementById("Meals").style.animation = "none";
					// }, 1250);
				}}
			>
				View meal details
			</button>
		</div>
	);

	return htmlBody;
};
